module.exports = __webpack_public_path__ + "static/aga-social-6939662d34261a31561f759b142d0b8f.jpg";